<script lang="ts">
	import '$lib/css/style.css';
	import { waitLocale, locale } from 'svelte-i18n';

	export const load = async ({ url }: any) => {
		if (url) {
			const language = url.pathname.split('/').pop() ? url.pathname.split('/').pop() : 'en';
			locale.set(`${language}`);
		}
		await waitLocale();
	};
</script>

<main class="cursor-default">
	<slot />
</main>


